$(function() {
    //BEGIN
    $(".careers-accordion__title").on("click", function(e) {
        e.preventDefault();
        var $this = $(this);
        if (!$this.hasClass("careers-accordion-active")) {
            $(".careers-accordion__content").slideUp(400);
            $(".careers-accordion__title").removeClass("careers-accordion-active");
            $('.careers-accordion__arrow').removeClass('careers-accordion__rotate');
        }
        $this.toggleClass("careers-accordion-active");
        $this.next().slideToggle();
        $('.careers-accordion__arrow',this).toggleClass('careers-accordion__rotate');
    });
    //END
});
$(function() {
    //BEGIN
    $(".privacy-accordion__title").on("click", function(e) {
        e.preventDefault();
        var $this = $(this);
        if (!$this.hasClass("privacy-accordion-active")) {
            $(".privacy-accordion__content").slideUp(400);
            $(".privacy-accordion__title").removeClass("privacy-accordion-active");
            $('.privacy-accordion__arrow').removeClass('privacy-accordion__rotate');
        }
        $this.toggleClass("privacy-accordion-active");
        $this.next().slideToggle();
        $('.privacy-accordion__arrow',this).toggleClass('privacy-accordion__rotate');
    });
    //END
});
$(function() {
    //BEGIN
    $(".tc-accordion__title").on("click", function(e) {
        e.preventDefault();
        var $this = $(this);
        if (!$this.hasClass("tc-accordion-active")) {
            $(".tc-accordion__content").slideUp(400);
            $(".tc-accordion__title").removeClass("tc-accordion-active");
            $('.tc-accordion__arrow').removeClass('tc-accordion__rotate');
        }
        $this.toggleClass("tc-accordion-active");
        $this.next().slideToggle();
        $('.tc-accordion__arrow',this).toggleClass('tc-accordion__rotate');
    });
    //END
});
$(function() {
    //BEGIN
    $(".faq-accordion__title").on("click", function(e) {
        e.preventDefault();
        var $this = $(this);
        if (!$this.hasClass("faq-accordion-active")) {
            $(".faq-accordion__content").slideUp(400);
            $(".faq-accordion__title").removeClass("faq-accordion-active");
            $('.faq-accordion__arrow').removeClass('faq-accordion__rotate');
        }
        $this.toggleClass("faq-accordion-active");
        $this.next().slideToggle();
        $('.faq-accordion__arrow',this).toggleClass('faq-accordion__rotate');
    });
    //END
});

$(function() {
    //BEGIN
    $(".faq-sections__text > p > strong").on("click", function(e) {
        e.preventDefault();
        $(this).parent().toggleClass('show-text');
        $(this).parent().siblings('.faq-sections__text > p').removeClass('show-text');
    });
    //END
});
